import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=2950a7e3&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&lang=js&"
export * from "./ProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=2950a7e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950a7e3",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/product_item.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Foffers%2FProductItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports